//jquery cookie
jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};                                              

//product
$(function() {
  var allImages = $("div.product-single__image-wrapper");
  function goNext(previousIndex, nextIndex) {
    $(allImages[previousIndex]).addClass("hide");
    $(allImages[nextIndex]).removeClass("hide");
  }
  
  function goRight(e) {
    e.preventDefault();
    if (allImages.length < 2) return;
    for (var i = 0; i < allImages.length; i++) {
      if ($(allImages[i]).css("display") == "block") {
        var nextIndex = i < allImages.length - 1 ? i + 1 : 0;
        goNext(i, nextIndex);
        break;
      }
    }
  }
  
  function goLeft(e) {
    e.preventDefault();
    if (allImages.length < 2) return;
    for (var i = 0; i < allImages.length; i++) {
      if ($(allImages[i]).css("display") == "block") {
        var nextIndex = i > 0 ? i - 1 : allImages.length - 1;
        goNext(i, nextIndex);
        break;
      }
    }
  }
  
  $('a.product-go-left').click(goLeft);
  $('a.product-go-right').click(goRight);
  
  //swipping
  document.addEventListener('touchstart', handleTouchStart, false);        
  document.addEventListener('touchmove', handleTouchMove, false);

  var xDown = null;                                                        
  var yDown = null;

  function getTouches(evt) {
    return evt.touches ||             // browser API
           evt.originalEvent.touches; // jQuery
  }                                                     

  function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];                                      
    xDown = firstTouch.clientX;                                      
    yDown = firstTouch.clientY;                                      
  };  

  function handleTouchMove(evt) {
    if ( ! xDown || ! yDown ) {
      return;
    }

    var xUp = evt.touches[0].clientX;                                    
    var yUp = evt.touches[0].clientY;

    var xDiff = xDown - xUp;
    var yDiff = yDown - yUp;

    if (xDiff > 5) {
      if (getTouches(evt)[0].target.id.indexOf("ProductImage") === 0) {
        goLeft();
      }
    } else if (xDiff < -5) {
      if (getTouches(evt)[0].target.id.indexOf("ProductImage") === 0) {
        goRight();
      }
    }

    /* reset values */
    xDown = null;
    yDown = null;                                             
  };
  
  //descriptions
  var selectedIndex = 0;
  var totalMenuItems = $('ul.product-tabs-menu li').length;

  $('ul.product-tabs-menu li a').click(function(item) {
    var index = $('ul.product-tabs-menu li a').index(this);
    if (index != selectedIndex) {
      selectedIndex = index;
      for (var i = 0; i < totalMenuItems; i++) {
        $($("ul.product-tabs-menu li a")[i]).css("font-weight", i == selectedIndex ? "bold" : "normal");
        $($("div#product-tabs > div")[i]).css("display", i == selectedIndex ? "block" : "none");
      }
    }
  });
  
  // ga tracking
  
  // quantity
  function parseQuantity() {
    var quantity = parseInt($("input.quantity-selector").val());
    if (!Number.isInteger(quantity) || quantity <= 0) {
      quantity = 0;
    }
    return quantity;
  }
  
  $("a.product-quantity-minus").click(function() {
  	var nextQuantity = Math.max(parseQuantity() - 1, 1);
    if (!$("input.quantity-selector").is(":disabled")) {
      $("input.quantity-selector").val(nextQuantity);
    }
  });
  $("a.product-quantity-plus").click(function() {
    var nextQuantity = parseQuantity() + 1;
    if (!$("input.quantity-selector").is(":disabled")) {
      $("input.quantity-selector").val(nextQuantity);
    }  
  });
  
  // variant
  $("div.product-variant-selector a").click(function(event) {
    var selectedVariant = $(event.currentTarget);
    $("div.product-variant-selector a").each(function() {
      $(this).removeClass("variant-selected");
    });
    
    selectedVariant.addClass("variant-selected");
    $("select.single-option-selector").val(selectedVariant.html()).change();
  });
});

//testimonial
$(function() {
  var testimonialIndex = 0;
  var testimonialTotal = $('.testimonial-one').length;
  
  function showTestimonial(nextIndex) {
    $($('.testimonial-one')[testimonialIndex]).css('display', 'none');
    testimonialIndex = nextIndex;
    $($('.testimonial-one')[testimonialIndex]).css('display', '');
  }
  
  $('.testimonial-left').click(function() {
    var next = testimonialIndex == 0 ? testimonialTotal - 1 : testimonialIndex - 1;
    showTestimonial(next);
  });
  $('.testimonial-right').click(function() {
    var next = testimonialIndex == testimonialTotal - 1 ? 0 : testimonialIndex + 1;
    showTestimonial(next);
  });
});

//mobile
$(function() {
  var isUS = window.location.host.toLowerCase().indexOf('us') == 0;  
  var indexes = [];
  
  function showMenu() {
    var itemHolder = document.getElementById("MobileMenu");
    itemHolder.innerHTML = "";

    var target = mobileLinks;
    if (indexes.length > 0) {
      var backButton = document.createElement("li");
      backButton.innerHTML = "<a class='span-mobile-back'><span class='icon icon-arrow-left' aria-hidden='true'></span>BACK</a>";
      itemHolder.appendChild(backButton);
	  
      var viewAllURL = "#";
      for (i of indexes) {
        viewAllURL = target[i].url;
        target = target[i].children;
      }
      
      if (viewAllURL != "/") {
        var viewAllButton = document.createElement("li");
        viewAllButton.innerHTML = "<a href='" + viewAllURL + "'>VIEW ALL</a>";
        itemHolder.appendChild(viewAllButton);
      }
    }

    for (var i = 0; i < target.length; i++) {
      var item = target[i];
      var created = document.createElement("li");
      if (item.children != null) {
        created.innerHTML = "<a class='span-mobile-submenu' data-next='" + i + "'>" + item.title
        + "<span class='icon icon-arrow-right' aria-hidden='true'></span>"
        + "</a>";
      } else {
        var url = isUS && (item.parent == null || item.parent === 7) && item.title.indexOf('BRANDS') < 0 && item.title.indexOf('GIFT CARDS') < 0 
        && item.title.indexOf('CAT') < 0 && item.title.indexOf('VALENTINES DAY') < 0 && item.title.indexOf('LIFE') < 0 && item.title.indexOf('CLEARANCE') < 0 ? item.url + '-in-us' : item.url;
        created.innerHTML = "<a href='" + url + "'>" + item.title + "</a>";
      }
      
      if (!isUS || (created.innerHTML.indexOf('SNACK') < 0 && created.innerHTML.indexOf("Bocce's") < 0)) {
        itemHolder.appendChild(created);
      }
    }
  }

  function onTrigger() {
    if ($(".span-mobile-menu").is(":visible")) {
      $('body').css('overflow', 'scroll');
    } else {
      $('body').css('overflow', 'hidden');
      $('.span-mobile-menu').css('height', (window.innerHeight - 28) + 'px');
    }

    $(".span-mobile-menu").toggle();
  }

  showMenu();
  $(".mobile-nav-trigger").on("click", onTrigger);
  $(".span-mobile-close").on("click", onTrigger);
  $('body').on('click', '.span-mobile-submenu', function() {
    indexes.push(parseInt($(this).data('next')));
    showMenu();
  });
  $('body').on('click', '.span-mobile-back', function() {
    indexes.pop();
    showMenu();
  });
});

//Customized currency selector
$('.shopify-currency-form select').on('change', function() {
  $(this)
    .parents('form')
    .submit();
});

$(".currency-selector-cad").on("click", function() {
  if ($('.shopify-currency-form select').val() != 'CAD') {
  	$('.shopify-currency-form select').val('CAD').change();
  }
});

$(".currency-selector-usd").on("click", function() {
  if ($('.shopify-currency-form select').val() != 'USD') {
  	$('.shopify-currency-form select').val('USD').change();
  }
});

// news letter
var ppModal = document.getElementsByClassName("popup-modal")[0];
var ppEmail = document.getElementsByClassName("popup-email")[0];
var ppSubscribe = document.getElementsByClassName("popup-subscribe")[0];
var ppClose = document.getElementsByClassName("popup-modal-close")[0];

ppClose.onclick = function() {
  ppModal.style.display = "none";
}

window.onclick = function(event) {
  if (event.target == ppModal) {
    ppModal.style.display = "none";
  }
}

ppEmail.addEventListener("keyup", function(event) {
  if (event.keyCode === 13) {
    event.preventDefault();
    ppSubscribe.click();
  }
});

ppSubscribe.onclick = function() {
  var email = $('input.popup-email').val();
  $('#contact_form #Email').val(email);
  document.getElementById('contact_form').submit();
};

// conditional
/*
var crawlerRegex = /bot|crawler|spider|crawling/i;
if (!crawlerRegex.test(navigator.userAgent)) {
  function switchDomain(countryCode) {
    
    var tab = ".popup-content-" + countryCode;
    $('.popup-modal-content > div').hide();
    $(tab).show();
    setTimeout(function() {
        ppModal.style.display = "block";
    }, 500);
    
  }
  
  function warnSnack() {
    $('i.snack-warning').css("display", "block");
  }

  if ($.cookie('currency') == null) {
    $.ajax({
      url: 'https://freegeoip.app/json/',
      type: 'GET',
      dataType: 'json',
      headers: {
        'Access-Control-Allow-Origin': 'https://' + window.location.host
      },
      success: function(location) {
        var domainCountry = window.location.host.toLowerCase().indexOf('us') == 0 ? "US" : "CA";  
        var detectedCountry = location.country_code == 'CA' ? 'CA' : 'US';
        if (location.country_code == 'CA') { // Default shop currency
          $.cookie('currency', 'CAD', { expires: 5/1440, path: '/'});
        } else { // Fallback currency
          $.cookie('currency', 'USD', { expires: 5/1440, path: '/'});
          warnSnack();
        }
        if (detectedCountry != domainCountry) {
          switchDomain(detectedCountry.toLowerCase());
        }
      }
    });
  } else if ($.cookie('currency') == 'USD') {
  	warnSnack();
  } else if (window.location.host.toLowerCase().indexOf('us') == 0) {
    warnSnack();
  }
  
}
*/

// cart
$('a.cart-show-coupon').click(function(e) {
  e.preventDefault();
  $('.cart-subtotal-container').hide();
  $('.cart-coupon-container').show();
  $('div.cart-coupon-subtotal-container').show();
});


var target = $('div.cart-coupon-container')[0];
if (target != null) {
  var observer = new MutationObserver(function(mutations) {
    if ($('.docapp-est-total span.money').length == 1) {
      var isUS = window.location.host.toLowerCase().indexOf('us') == 0;
      var currencyCode = isUS ? 'USD' : 'CAD';
      var subtotal = parseFloat($('.docapp-est-total span.money')[0].innerText.substring(1));
      var discount = originalSubtotal - subtotal;
      
      if (isUS && $('.docapp-coupon-input--bean-container--bean').text().toUpperCase().includes('5OFF40US')) {
      	var diff = discount - 5;
        discount = 5;
        subtotal += diff;
      }
      
      var shippingSubtotal = nonGiftSubtotal - discount;
      
      var localCharge = shippingSubtotal < 75 ? '$13.50' : 'free';
      var shipCharge = shippingSubtotal < 75 ? (isUS ? '$8.50' : '$13.50') : 'free';
      var canadaCharge = shippingSubtotal < 100 ? '$13.50' : 'free';
      var table = '<table class="static-table"><tbody>' 
      + (discount >= 0.01 ? '<tr><td>Discount:</td><td>' + discount.toFixed(2) + ' ' + currencyCode + '</td></tr>' : '')
      + '<tr><td>Subtotal:</td><td><strong>' + subtotal.toFixed(2) + ' ' + currencyCode + '</strong></td></tr>';
      var shippingText = '';
      if (shippingSubtotal < 100 && shippingSubtotal > 50) {
        if (isUS) {
          if (shippingSubtotal < 75) {
          	shippingText = '🚚 $' + (75 - shippingSubtotal).toFixed(2) + ' away from free US shipping';
          }
        } else {
          if (shippingSubtotal < 75) {
          	shippingText = '🚚 $' + (75 - shippingSubtotal).toFixed(2) + '/$' + (100 - shippingSubtotal).toFixed(2) + ' away from free Ontario/Canada shipping';
          } else {
            shippingText = '🚚 Enjoy free Ontario shipping, and $' + (100 - shippingSubtotal).toFixed(2) + ' away from free Canada shipping';
          }
        }
      }
      if (hasSteps) {
        table += '<tr><td>Shipping*:</td><td>calculated at checkout</td></tr></tbody></table>';
      } else if (shippingSubtotal == 0) {
        table += '<tr><td>Shipping*:</td><td>free e-gift card delivery</td></tr></tbody></table>';
      } else if (isUS) {
        table += '<tr><td>Shipping*:</td><td>' + shipCharge + ' <a href="/pages/shipping-information#USShipping">US shipping</a></td></tr></tbody></table>';
      } else if (localCharge == 'free' && canadaCharge == 'free') {
        table += '<tr><td>Shipping*:</td><td>' + shipCharge + ' <a href="/pages/shipping-information#USShipping">Shipping</a></td></tr></tbody></table>';
      } else {
        table += '<tr><td>Shipping*:</td><td>' + localCharge + ' <a href="/pages/shipping-information#LocalDelivery">Shipping</a></td></tr>';
        table += '<tr><td></td><td>or ' + canadaCharge + ' <a href="/pages/shipping-information#CanadaShipping">Shipping</a></td></tr></tbody></table>';
      } 
      //else {
      //	table += '<tr><td>Shipping*:</td><td>' + localCharge + ' <a href="/pages/shipping-information#LocalDelivery">GTA shipping</a></td></tr>';
      //  table += '<tr><td></td><td>or ' + canadaCharge + ' <a href="/pages/shipping-information#CanadaShipping">Canada shipping</a></td></tr></tbody></table>';
      //}

      $('div.cart-coupon-subtotal-container').html(table);
      $('div.docapp-est-total').hide();
            
      if (shippingText != '') {
        $('h5.free-shipping-banner').text(shippingText);
        $('h5.free-shipping-banner').show();
      } else {
        $('h5.free-shipping-banner').hide();
      }
    }
  });
  observer.observe(target, {
    childList: true,
    subtree: true
  });
}

var hasCoupon = $.cookie('docapp-coupon') != null && $.cookie('docapp-coupon') != 'null';
if (hasCoupon) {
  $('.cart-subtotal-container').hide();
  $('.cart-coupon-container').show();
  $('div.cart-coupon-subtotal-container').show();
}

// cart quantity
function parseQuantity(index) {
  var quantity = parseInt($("#updates_" + index).val());
  if (!Number.isInteger(quantity) || quantity <= 0) {
    quantity = 0;
  }
  return quantity;
}

$("a.cq-minus").click(function(e) {
  var index = $(e.currentTarget).data("index");
  var currentQuantity = parseQuantity(index);
  if (currentQuantity == 1) return;
  var nextQuantity = Math.max(currentQuantity - 1, 1);
  $("#updates_" + index).val(nextQuantity).change();
  $(".update-cart").click();
});
$("a.cq-plus").click(function(e) {
  var index = $(e.currentTarget).data("index");
  var nextQuantity = parseQuantity(index) + 1;
  $("#updates_" + index).val(nextQuantity).change();
  $(".update-cart").click();
});

// country switch
curMapping = {
  "new-arrivals": "new-arrivals-in-us",
  "sale": "sale-in-us",
  "birthday-gifts": "birthday-gifts-in-us",
  "best-sellers": "best-sellers-in-us",
  "fall-halloween": "fall-halloween-in-us",
  "holiday-christmas-2021": "holiday-christmas-2021-in-us"
}
var isUS = window.location.host.toLowerCase().indexOf('us') == 0;
var curPath = window.location.pathname.replace(/\?shpxid=.+/, '');
var targetPath = isUS ? "https://thetailstory.com" : "https://us.thetailstory.com";
if (isUS) {
  for (var k in curMapping) {
    curPath = curPath.replace(curMapping[k], k);
  }
} else {
  for (var k in curMapping) {
    curPath = curPath.replace(k, curMapping[k]);
  }
}
targetPath += curPath.replace('in-us-in-us', 'in-us');
$("a.link-switch-country").attr("href", targetPath);

$("img.mobile-cur-country-img").click(function(e) {
  var switcher = $(".mobile-country-switcher")[0];
  if ($(switcher).css("display") == "none") {
    $(switcher).css("display", "inline-block");
  } else {
    $(switcher).css("display", "none");
  }
});

if (window.location.href.indexOf('shpxid') > 0) {
 	console.log(targetPath);
	window.location.replace(targetPath);
}

// floating menu
var lastScrollTop = 0;
var desktopMenu = $("div.desktop-nav").clone();
$(desktopMenu).css({
  "display": "none",
  "position": "fixed",
  "top": "6px",
  "left": "0px",
  "z-index": "100",
  "background": "white"
});

$(window).scroll(function(event){
  if ($(window).width() < 900) return;
  var st = $(this).scrollTop();
  if (lastScrollTop < 163 && st >= 163){
	//float menu
	$(desktopMenu).appendTo("div.menu-container");
    $(desktopMenu).show();
  } else if (lastScrollTop >= 163 && st < 163) {
	//unfloat menu
    $(desktopMenu).hide();
    $(desktopMenu).remove();
  }
  lastScrollTop = st;
});